<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
      <AccountTabs></AccountTabs>
      <section ref="content" id="content" class="section subnav no-vpadding">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <div v-show="field == 'name' || !field" class="columns is-mobile is-centered">
                <div class="column is-full has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input ref="name" @click="hideTabs(); field = 'name'" @focus="hideTabs(); field = 'name'" @blur="showTabs()" class="input" type="text" :placeholder="$t('Name')" v-model="household.name" autocomplete="off" required>
                            <span class="icon is-small is-left">
                                <i class="fa fa-home"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="field == 'address' || !field" class="columns is-mobile is-centered">
                <div class="column is-full">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input ref="address" @click="hideTabs(); field = 'address'" @focus="hideTabs(); field = 'address'" @blur="showTabs()" class="input" type="text" :placeholder="$t('Address')" v-model="household.address" autocomplete="off">
                            <span class="icon is-small is-left">
                                <i class="fa fa-map-marker"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="field == 'address' || !field" class="columns is-mobile has-text-centered">
                <div class="column is-two-fifths">
                    <label class="label">{{ $t("Latitude") }}</label>
                    <div class="control has-icons-left">
                        <input @click="hideTabs(); field = 'address'" @focus="hideTabs(); field = 'address'" @blur="showTabs()" class="input" type="text" :placeholder="$t('Latitude')" v-model="household.latitude" autocomplete="off">
                        <span class="icon is-small is-left">
                            <i class="fa fa-map-marker"></i>
                        </span>
                    </div>
                </div>
                <div class="column is-two-fifths">
                    <label class="label">{{ $t("Longitude") }}</label>
                    <div class="control has-icons-left">
                        <input @click="hideTabs(); field = 'address'" @focus="hideTabs(); field = 'address'" @blur="showTabs()" class="input" type="text" :placeholder="$t('Longitude')" v-model="household.longitude" autocomplete="off">
                        <span class="icon is-small is-left">
                            <i class="fa fa-map-marker"></i>
                        </span>
                    </div>
                </div>
                <div class="column is-one-fifth has-text-centered">
                    <label class="label">&nbsp;</label>
                    <a @click="updateLocation()" class="button is-info is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-map-marker"></i>
                        </span>
                    </a>
                </div>
            </div>
            <div v-show="field == 'asset' || !field" class="columns is-mobile is-centered">
                <div class="column is-full">
                    <div class="control has-icons-left">
                        <div class="select is-fullwidth">
                            <select ref="waterSystem" @click="field = 'asset'" @focus="field = 'asset'" @change="updateTaps()" v-model.number="household.systemID" required>
                                <option disabled value="disabled">{{ $t("WaterSystem")}}</option>
                                <option v-for="waterSystem in waterSystems" :key="waterSystem.waterSystemID" :value="waterSystem.waterSystemID">{{ waterSystem.name }}</option>
                            </select>
                        </div>
                        <div class="icon is-small is-left">
                            <i class="fa fa-tint"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="field == 'asset' || !field" class="columns is-mobile is-centered">
                <div class="column is-full">
                    <div class="control has-icons-left">
                        <div class="select is-fullwidth">
                            <select ref="asset" @click="field = 'asset'" @focus="field = 'asset'" v-model.number="household.assetID" required>
                                <option disabled value="disabled">{{ $t("Tap")}}</option>
                                <option v-for="asset in assets" :key="asset.assetID" :value="asset.assetID">{{ asset.name }} ({{ asset.connected ? $t("Online") : $t("Offline") }})</option>
                            </select>
                        </div>
                        <div class="icon is-small is-left">
                            <i class="fa fa-tint"></i>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div v-show="!field" class="columns is-mobile is-centered">
                <div class="column is-full has-text-centered">
                    <label class="label">{{ $t("RegistrationDate") }}</label>
                    <div class="control has-icons-left">
                        <input class="input" type="text" :value="household.signUpDate ? new Date(household.signUpDate).toLocaleDateString() : ''" readonly>
                        <span class="icon is-small is-left">
                            <i class="fa fa-user"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div v-show="!field" class="columns is-mobile is-centered">
                <div class="column is-full has-text-centered">
                    <label class="label">{{ $t("RegisteredBy") }}</label>
                    <div class="control has-icons-left">
                        <input class="input" type="text" :value="household.createdBy ? household.createdBy : ''" readonly>
                        <span class="icon is-small is-left">
                            <i class="fa fa-user"></i>
                        </span>
                    </div>
                </div>
            </div> -->
            <div v-show="field != null" class="columns is-mobile is-centered">
                <div class="column is-half has-text-centered">
                    <a @click="field = null" class="button is-info is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-times"></i>
                        </span>
                        <span>{{ $t("Cancel") }}</span>
                    </a>
                </div>
                <div class="column is-half has-text-centered">
                    <a @click="save()" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa" :class="[loading ? 'fa-spinner fa-spin' : 'fa-save']"></i>
                        </span>
                        <span>{{ $t("SaveChanges") }}</span>
                    </a>
                </div>
            </div>
      </section>
      <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
import AccountTabs from "@/components/AccountTabs.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "AccountHousehold",
  components: {
    Header,
    Modal,
    AccountTabs,
    Notification,
    NavigationTabs,
    Spinner
  },
  async mounted()
  {
    const response = await this.$http.get(`/Household`);
    this.household = response.data.household;

    await this.getWaterSystems();
    await this.updateTaps();

    if(this.household.name == "Unknown" || this.household.numberOfPeople < 1)
    {
        this.modal.title = this.$t("UnknownHousehold");
        let body = `<p>${this.$t("PleaseCorrectBody")}</p>`;
        
        if(this.household.name == "Unknown")
        {
            body += `<p>${this.$t("UnknownHousholdName")}</p>`;
        }

        if(this.household.numberOfPeople < 1)
        {
            body += `<p>${this.$t("UnknownHousholdNumber")}</p>`;
        }
        
        this.modal.body = body;
        this.modal.className = "is-active";
    }
  },
  data () {
    return {
        field: null,
        household: {},
        assets: [],
        modal: {
            title: null,
            body: null,
            centerBody: true,
            className: "",
            buttons:
            [
                {id: 0, title: this.$t("OK"), className: "is-primary", click: () => { this.modal.className = ""; }}
            ]
        }
    }
  },
  methods:
  {
    updateLocation: function()
    {
        navigator.geolocation.getCurrentPosition(position =>
        {
            if (position)
            {
                this.household.latitude = position.coords.latitude;
                this.household.longitude = position.coords.longitude;
            }
        });
    },
    updateTaps: async function()
    {
        const system = this.$refs.waterSystem.value || this.household.systemID;
        const response = await this.$http.get(`/Asset?waterSystemId=${system}`);
        this.assets = response.data.assets;
    },
    save: async function() {
        if(this.loading)
        {
            return;
        }

        let body = {};

        switch(this.field)
        {
            case "name":
                if(!this.$refs.name.checkValidity())
                {
                    this.$refs.name.reportValidity();
                    return;
                }
                body.name = this.household.name;
                break;

            case "address":
                body.address = this.household.address;

                if(this.household.latitude && this.household.longitude)
                {
                    body.latitude = this.household.latitude;
                    body.longitude = this.household.longitude;
                }
                break;

            case "asset":
                if (this.$refs.waterSystem.selectedIndex == 0) {
                    this.$refs.waterSystem.selectedIndex = -1;
                }

                if(!this.$refs.waterSystem.checkValidity())
                {
                    this.$refs.waterSystem.reportValidity();
                    return;
                }

                if (this.$refs.asset.selectedIndex == 0) {
                    this.$refs.asset.selectedIndex = -1;
                }

                if(!this.$refs.asset.checkValidity())
                {
                    this.$refs.asset.reportValidity();
                    return;
                }

                body.assetID = this.household.assetID;
                break;
        }

        this.field = null;
        this.$refs.content.scrollTo(0, 0);

        try
        {
            const response = await this.$http.post(`/Household`, body);
            this.notification =
            {
                show: true,
                className: "is-success",
                text: this.$t("Updated")
            }
        }

        catch(error)
        {
            if(error.response)
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: error.response.data.message
                }
            }
            
            else
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: this.$t("Error")
                }
            }
        }
    }
  }
};
</script>
